import { CLIENT_USER_FILTERS_DEFAULT as DEFAUT } from "../clientFiltersDefault";
import { statutCompteLabel, statutContratLabel, typeClientLabel } from "./clientPresets";

// Patch « remettre ce champ à sa valeur par défaut ».
const vide = (key) => ({ [key]: DEFAUT[key] });

const CHAMPS_TEXTE = [
  ["email", "Email"],
  ["nomPrenomClient", "Nom"],
  ["nomSociete", "Société"],
  ["sirenOuSiret", "SIREN/SIRET"],
];

// « A, B » si deux au plus, sinon « 3 compagnies ».
const nommer = (ids, referentiel = [], singulier, pluriel, cle = "name") => {
  if (ids.length > 2) return `${ids.length} ${pluriel}`;
  return ids.map((id) => (referentiel.find((r) => r.id === id) || {})[cle] || id).join(", ");
};

/**
 * Jetons de la ligne de résumé : { key, label, clear }.
 * ctx = { POLICIES_STATUS, ACCOUNT_STATUS, insuranceCompanies, productTypes,
 * products, producers } — tous optionnels (les libellés dégradent sur l'id).
 */
export const buildFilterTokens = (filtres, ctx = {}) => {
  const tokens = [];

  CHAMPS_TEXTE.forEach(([key, prefixe]) => {
    if (filtres[key]) tokens.push({ key, label: `${prefixe} : ${filtres[key]}`, clear: vide(key) });
  });
  if (filtres.numeroContrat) {
    tokens.push({ key: "numeroContrat", label: `Contrat n° ${filtres.numeroContrat}`, clear: vide("numeroContrat") });
  }

  if (filtres.typeClient) {
    tokens.push({ key: "typeClient", label: typeClientLabel(filtres.typeClient), clear: vide("typeClient") });
  }

  // Le défaut « En cours » et « tous » ("") n'ont pas de jeton : le segment de
  // la barre les montre déjà.
  if (filtres.statutContrat !== "" && Number(filtres.statutContrat) !== DEFAUT.statutContrat) {
    tokens.push({
      key: "statutContrat",
      label: `Contrat : ${statutContratLabel(filtres.statutContrat, ctx.POLICIES_STATUS)}`,
      clear: vide("statutContrat"),
    });
  }

  if (filtres.statutCompte !== "" && filtres.statutCompte !== null && filtres.statutCompte !== undefined) {
    tokens.push({
      key: "statutCompte",
      label: `Compte : ${statutCompteLabel(filtres.statutCompte, ctx.ACCOUNT_STATUS)}`,
      clear: vide("statutCompte"),
    });
  }

  if (filtres.compagniesAssurances?.length) {
    tokens.push({
      key: "compagniesAssurances",
      label: `Compagnies : ${nommer(filtres.compagniesAssurances, ctx.insuranceCompanies, "compagnie", "compagnies")}`,
      clear: vide("compagniesAssurances"),
    });
  }
  if (filtres.typesProduits?.length) {
    tokens.push({
      key: "typesProduits",
      label: `Types : ${nommer(filtres.typesProduits, ctx.productTypes, "type", "types de produit")}`,
      clear: vide("typesProduits"),
    });
  }
  if (filtres.produits?.length) {
    tokens.push({
      key: "produits",
      label: `Produits : ${nommer(filtres.produits, ctx.products, "produit", "produits")}`,
      clear: vide("produits"),
    });
  }

  if (filtres.partenaire) {
    const nom = (ctx.producers || []).find((p) => p.id === filtres.partenaire)?.company;
    tokens.push({ key: "partenaire", label: `Partenaire : ${nom || filtres.partenaire}`, clear: vide("partenaire") });
  }

  if (filtres.auMoins1Contrat) {
    tokens.push({ key: "auMoins1Contrat", label: "Au moins 1 contrat", clear: vide("auMoins1Contrat") });
  }
  if (filtres.avecEcheancierOuMensualisation) {
    tokens.push({
      key: "avecEcheancierOuMensualisation",
      label: "Avec échéancier ou mensualisation",
      clear: vide("avecEcheancierOuMensualisation"),
    });
  }

  return tokens;
};

// Badge du bouton « Filtres » : nombre de jetons, sans avoir besoin du ctx.
export const countActiveFilters = (filtres = {}) => buildFilterTokens(filtres).length;
